import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { List } from 'react-virtualized';
import { compose, withProps } from 'recompose';
import { getBackgroundColor } from '@bubble-ui/temp-form-element-colors';
import { withDesignVersion } from '@bubble-ui/provider-design-version';
import Row from './row';

var DropdownSelector = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownSelector, _React$Component);

  var _super = _createSuper(DropdownSelector);

  function DropdownSelector(props) {
    var _this;

    _classCallCheck(this, DropdownSelector);

    _this = _super.call(this, props);
    _this.rowRenderer = _this.rowRenderer.bind(_assertThisInitialized(_this));
    _this.ref = /*#__PURE__*/React.createRef();
    return _this;
  }

  _createClass(DropdownSelector, [{
    key: "rowRenderer",
    value: function rowRenderer(_ref) {
      var _this2 = this;

      var index = _ref.index,
          key = _ref.key,
          style = _ref.style;
      var _this$props$itemList$ = this.props.itemList[index],
          item = _this$props$itemList$.item,
          options = _this$props$itemList$.options;
      var hint = options.hint,
          customValue = options.customValue;
      var itemRow = hint || customValue ? item.label : this.props.highlightMatch(item.label, this.props.searchString);

      if (this.props.customRowRenderer) {
        itemRow = this.props.customRowRenderer(item, key, options.showMatch);
      } else if (item.icon) {
        itemRow = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
          style: {
            paddingRight: 7
          }
        }, item.icon), " ", itemRow);
      }

      return /*#__PURE__*/React.createElement("div", {
        key: key,
        style: style,
        "data-cid": "row ".concat(item.key)
      }, /*#__PURE__*/React.createElement(Row, {
        onMouseDown: function onMouseDown() {
          return _this2.props.onSelectSuggestion({
            item: item,
            options: options
          });
        },
        separator: options.separator,
        focused: index === this.props.focusedElementIndex,
        title: options.title,
        hint: hint,
        styleSheet: this.props.styleSheet,
        disabled: item.disabled
      }, itemRow));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          length = _this$props.itemList.length,
          focusedElementIndex = _this$props.focusedElementIndex,
          background = _this$props.background,
          styleSheet = _this$props.styleSheet;
      var _styleSheet$dropdown = styleSheet.dropdown,
          lineHeight = _styleSheet$dropdown.lineHeight,
          maxHeight = _styleSheet$dropdown.maxHeight;
      var height = length * lineHeight;
      var dropdownHeight = height < maxHeight ? height : maxHeight;
      var scrollToPosition = 0;

      if (focusedElementIndex <= length - 3) {
        // Regular scroll within list
        scrollToPosition = (focusedElementIndex - 1) * lineHeight;
      } else if (focusedElementIndex) {
        // Make sure we don't scroll down too far as rendering would act weirdly
        scrollToPosition = (length - 4) * lineHeight;
      }

      return /*#__PURE__*/React.createElement("div", {
        style: _objectSpread(_objectSpread({}, styleSheet.dropdown.containerStyle), {}, {
          background: background.toString()
        })
      }, /*#__PURE__*/React.createElement(List, {
        ref: this.ref,
        searchString: this.props.searchString // Pass searchstring to force re-rendering on each search
        ,
        focusedElementIndex: this.props.focusedElementIndex // Pass focusedElementIndex to force re-rendering on each search
        ,
        width: this.props.width - 10 // - 10 to take field paddings into account
        ,
        height: dropdownHeight,
        rowCount: length,
        rowHeight: lineHeight,
        rowRenderer: this.rowRenderer,
        overscanRowCount: 10,
        scrollTop: scrollToPosition,
        style: {
          outline: 'none'
        }
      }));
    }
  }]);

  return DropdownSelector;
}(React.Component);

export default compose(withDesignVersion, withProps(function (_ref2) {
  var designVersion = _ref2.designVersion;
  return {
    background: getBackgroundColor({
      designVersion: designVersion
    })
  };
}))(DropdownSelector);
//# sourceMappingURL=dropdown.js.map